import { WorkItemFilters } from "./historicalDataApi.query";
import { EmailContentQuery } from "./searchApi.models";

export function buildEmailSearchQuery(filters: Partial<WorkItemFilters>, agentId: string): EmailContentQuery {
  return {
    search: {
      term: filters.searchTerm ?? "",
      searchIn: filters.searchField !== undefined
        ? filters.searchField
        : "CustomerAddress",
    },
    filters: {
      agentId,
      businessUnitFilter: filters.businessUnitId
        ? { businessUnitId: filters.businessUnitId }
        : undefined,
      channelId: filters.channelIds?.length
        ? Number(filters.channelIds[0])
        : undefined,
      createdAtFrom: filters.from,
      createdAtTo: filters.to,
    },
  };
}
